"use strict";
/**
 * The CMS Page module provides access to content management pages from the EVA back-end * @preferred
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_1 = require("./base");
/**
 * Provides access to a content menu available in EVA
 */
var Station = /** @class */ (function (_super) {
    __extends(Station, _super);
    function Station() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Fetches the page content
     * @return {Promise<IEVAServiceResponse<EVA.Core.Services.GetStation, EVA.Core.Services.GetStationResponse>>} A promise resolving when the fetch from the back-end has completed
     */
    Station.prototype.fetch = function () {
        // Build the request data
        //
        var requestData = {
            ID: this.getId()
        };
        return _super.prototype.fetch.call(this, "GetStation", requestData);
    };
    return Station;
}(base_1.FetchableItem));
exports.Station = Station;
/**
 * Provides access to a list of stations for an organisation available in EVA
 */
var StationList = /** @class */ (function (_super) {
    __extends(StationList, _super);
    function StationList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Sets the organization id to retrieve the station list for
     * @param  {number} organizationId      The organization identifier
     * @return {void}                       This method doesn't return anything
     */
    StationList.prototype.setOrganizationId = function (organizationId) {
        this.organizationId = organizationId;
    };
    /**
     * Fetches the list of items
     * @return {Promise<IEVAServiceResponse<EVA.Core.StationDto, EVA.Core.Services.ListStationsForOrganizationUnit, EVA.Core.Services.ListStationsForOrganizationUnitResponse>>} A promise resolving when the fetch from the back-end has completed
     */
    StationList.prototype.fetch = function () {
        // Build the request data
        //
        var requestData = {
            PageConfig: this.getPageConfiguration(),
            OrganizationUnitID: this.organizationId
        };
        return _super.prototype.fetch.call(this, "ListStationsForOrganizationUnit", requestData);
    };
    return StationList;
}(base_1.FetchablePagedList));
exports.StationList = StationList;
